import { createTheme } from '@mui/material/styles';
import { paloNextTheme, tokens } from '@synergy/theme-palo';

const c = tokens.color;

/**
 * PALO, at the size a login screen needs.
 *
 * The backoffice contract holds a field at 29 pixels because a document mask
 * carries forty of them and every one saved is a row more on the screen. A
 * login carries two. At 29 the screen does not read as tidy, it reads as mean.
 *
 * So the identity is PALO — the accent, the ink scale, the corner radius, the
 * type, and the label that stands above its field instead of floating inside
 * it — and only the room around the two fields is the login's own.
 */
export const loginTheme = createTheme(paloNextTheme, {
    components: {
        // The backoffice canvas is the grey a card sits on. This page has no
        // card — the photo carries one half, the form stands plainly on the
        // other. PALO paints the body here rather than through the palette, so
        // this is the place that answers.
        MuiCssBaseline: {
            styleOverrides: {
                body: { backgroundColor: c.surface },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    height: 44,
                    fontSize: '0.875rem',
                },
                input: {
                    height: '100%',
                    boxSizing: 'border-box',
                    padding: '0 12px',
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontSize: '12px',
                    marginBottom: '5px',
                    // The forgotten-password and reset screens centre their
                    // text, which was invisible while the label floated inside
                    // the field. Standing above it, a label belongs at the left
                    // edge of the field it names, whatever the page centres.
                    textAlign: 'left',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    minHeight: 44,
                    fontSize: '0.875rem',
                    fontWeight: 560,
                },
                // The office sign-in is an alternative, not a warning: it takes
                // the quiet outline rather than the colour the backoffice keeps
                // for what cannot be undone.
                outlinedSecondary: {
                    color: c.ink,
                    borderColor: c.lineHard,
                    '&:hover': {
                        borderColor: c.ink3,
                        backgroundColor: c.surface2,
                    },
                },
            },
        },
    },
});
